/* eslint-disable camelcase */
import React from 'react';
import { Currency } from 'src/components/Currency';
import { GroupsDTO } from '../../utils/interfaces';
import { Group, GroupBox, Container, MonthInfo } from './styles';

interface SplittedAmountMonthPaidProps {
  group: GroupsDTO;
}

export const SplittedAmountMonthPaid: React.FC<SplittedAmountMonthPaidProps> = ({
  group,
}) => {
  return (
    <Container>
      <Group>
        <GroupBox>
          <MonthInfo>
            <div>Valor pago este mês</div>
            {group ? (
              <p>
                <Currency value={group?.splitted_amount} />
              </p>
            ) : (
              <p>
                <Currency value={0} />
              </p>
            )}
          </MonthInfo>
        </GroupBox>
      </Group>
    </Container>
  );
};
